import { LivePageWidgetConfig } from '../../../../types/window';
import { formatWildcardResponseData } from '../formatWildcardResponseData';

export const getServerData = (serverData: LivePageWidgetConfig['livePageData'], currentOpenSectionId: string) => {
    return serverData?.events?.length
        ? formatWildcardResponseData(serverData, currentOpenSectionId, serverData.subtabs[0].id)
        : null;
};
